export default "__VITE_ASSET__BMQf1fyU__"